<template lang="pug">
modal(:max-width="1024")
	.card.text-left
		.card-header.bg-info.text-white
			span.fa.fa-edit.mr-2
			| Redactar mensaje
			button.close(@click="cerrar") &times;
		.card-body
			b 
				| Destinatarios
			span.ml-2(@click="nuevoDestinatario", style="cursor:pointer;") (Añadir)
			br
			.input-group.input-group-sm.m-1(
				v-for="(destinatario, i) in destinatarios"
				:key="i"
			)
				.input-group-prepend
					button.btn-sm.btn(:class="destinatario.tipo === 'Para' ? 'btn-primary' : ''", @click="destinatarios[i].tipo = 'Para'") Para
				.input-group-append
					button.btn-sm.btn(:class="destinatario.tipo === 'CC' ? 'btn-primary' : ''", @click="destinatarios[i].tipo = 'CC'") CC
				.input-group-append
					button.btn-sm.btn(:class="destinatario.tipo === 'CCO' ? 'btn-primary' : ''", @click="destinatarios[i].tipo = 'CCO'") CCO
				input.form-control.form-control-sm(placeholder="dirección@email")
		.card-body.bg-light
			.form-group
				label
					b Asunto
				input.form-control
		.card-body.bg-light(style="height: 600px; padding-bottom: 50px;")
			vue-mce.editor(:config="configuracionEditor", v-model="cuerpo")
		.card-footer
			button.btn.btn-primary(@click="cerrar")
				span.fa.fa-send.mr-2
				| Enviar
</template>

<script>
export default {
	data () {
		return {
			destinatarios: [
				{
					email: '',
					tipo: 'Para'
				}
			],
			cuerpo: null,
			configuracionEditor: {
				menubar: false,
				theme: 'modern',
				plugins: [
					'advlist autolink lists link image charmap print preview anchor textcolor',
					'searchreplace visualblocks code fullscreen',
					'insertdatetime image media table contextmenu paste code help wordcount paste'
				],
				toolbar: 'insert paste | undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat',
				paste_as_text: true,
				table_default_attributes: {
					'border': '1'
				},
				table_default_styles: {
					'border-collapsed': 'collapse',
					'width': '100%'
				},
				table_responsive_width: true,
				content_style: `
					table {width: 100%;border-spacing: 0;border-collapse: separate;border: 1px solid #aaa;}
					table tr:nth-child(even) {background-color: #fafafa;}
					table td, table th {border: 1px solid #aaa; border-collapse:collapse;padding: 5px;}
				`,
				image_upload_tab: true,
				images_upload_url: '/src/modulos/webmail/php/api/upload-imagen.php',
				height: 300
			}
		}
	},
	methods: {
		nuevoDestinatario () {
			this.destinatarios.push({
				email: '',
				tipo: 'Para'
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/modulos/webmail/vue/components/redactar/redactar.vue